/* ============================================================
   Dathent — Autopilot enable-confirm dialog
   Controlled (parent owns `open`). Shown ONLY when the user turns autopilot
   ON, so they explicitly consent to automatic generation + publishing — it
   never pops up on its own. Two paths: Confirm (enable) or Edit Strategy
   (review cadence/channels first). Turning OFF never shows this.
   ============================================================ */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons as I } from './pack-icons';

export default function AutopilotIntroModal({ open, busy = false, onConfirm, onCustomize, onClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="apm-overlay" role="presentation" onClick={() => onClose?.()}>
      <div
        className="apm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="apm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="apm-close" onClick={() => onClose?.()} type="button" aria-label={t('autopilotIntro.dismiss')}>
          <I.x size={16} />
        </button>
        <span className="apm-icon"><I.sparkles size={20} /></span>
        <div className="eyebrow apm-eyebrow"><span>{t('autopilotIntro.eyebrow')}</span></div>
        <h2 className="apm-title" id="apm-title">{t('autopilotIntro.title')}</h2>
        <p className="apm-body">{t('autopilotIntro.body')}</p>
        <ul className="apm-points">
          <li><span className="apm-check"><I.check size={12} /></span> {t('autopilotIntro.point1')}</li>
          <li><span className="apm-check"><I.check size={12} /></span> {t('autopilotIntro.point2')}</li>
          <li><span className="apm-check"><I.check size={12} /></span> {t('autopilotIntro.point3')}</li>
        </ul>
        <div className="apm-actions">
          <button className="btn btn-ghost" onClick={() => onCustomize?.()} type="button">
            <I.edit size={13} /> {t('autopilotIntro.customize')}
          </button>
          <button className="btn btn-primary" onClick={() => onConfirm?.()} disabled={busy} type="button">
            <I.sparkles size={13} /> {busy ? t('autopilotIntro.enabling') : t('autopilotIntro.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
